import * as initActions from './init'
import * as commonActions from './common'
import * as casesActions from './cases'
import * as createCaseActions from './create-case'
import * as updateCaseCreationOrderActions from './update-case-creation-order'
import * as caseCreationOrdersActions from './case-creation-orders'
import * as caseCreationOrderFormActions from './case-creation-order-form'
import * as fetchDPUrlActions from './fetchDPUrlActions'

export default {
  ...initActions,
  ...commonActions,
  ...casesActions,
  ...createCaseActions,
  ...caseCreationOrdersActions,
  ...updateCaseCreationOrderActions,
  ...caseCreationOrderFormActions,
  ...fetchDPUrlActions
}
